/* eslint-disable react/button-has-type */
import React, { useContext } from 'react';
import TowersTable from './TowersTable';
import GeniatechContext from '../../../../../../context/GeniatechContext';
import TowerTable from './tower/TowerTable';

const TowersBody = () => {
  const { searchStatus, reset } = useContext(GeniatechContext);
  return (
    <div className="container">
      <div className="row mt-5">
        <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
          <div className="container">
            <div className="row mt-5">
              {searchStatus && (
                <div className="form-group ml-2">
                  <button onClick={reset} className="btn btn-green">
                    See All Towers
                  </button>
                </div>
              )}
              {searchStatus ? <TowerTable /> : <TowersTable />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TowersBody;
